import { useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { Outlet, useLocation } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';
import { RightRail } from './RightRail';
import { CommandPalette } from './CommandPalette';
import { CommandPaletteProvider } from './CommandPaletteProvider';

export function Shell() {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const { pathname } = useLocation();
  const { user } = useAuth();

  const showRail = pathname === '/' && user?.role === 'ADMIN';

  return (
    <CommandPaletteProvider>
      <div className="flex min-h-dvh bg-bg-0">
        <div className="hidden shrink-0 lg:flex">
          <Sidebar collapsed={sidebarCollapsed} onToggle={() => setSidebarCollapsed((c) => !c)} />
        </div>
        <div className="flex min-w-0 flex-1 flex-col">
          <TopBar />
          <main className="flex min-w-0 flex-1">
            <div
              key={pathname}
              className="mx-auto flex w-full min-w-0 max-w-[1280px] flex-1 flex-col px-4 pb-[max(2rem,env(safe-area-inset-bottom))] pt-5 sm:px-6 sm:pb-14 sm:pt-7 lg:px-8"
            >
              <Outlet />
            </div>
            {showRail && (
              <div className="hidden 2xl:block">
                <RightRail />
              </div>
            )}
          </main>
        </div>
        <CommandPalette />
      </div>
    </CommandPaletteProvider>
  );
}
